import React from "react";
import { useSelector } from "react-redux";
import DeletedTable from "./DeletedTable";
import { selContent, selDeletedItems } from "../../slice/librarySlice";

export default function DeleteTable(props) {
  const { handleDrawer } = props;
  const { current } = useSelector(selContent);
  const deleted = useSelector(selDeletedItems);

  return (
    <DeletedTable items={{ current, deleted }} handleDrawer={handleDrawer} />
  );
}
